var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"width":"25%","src":require("./assets/bf-image-footer.png")}}),_c('BfText',{attrs:{"msg":"Date is coming!"}}),_c('flip-countdown',{attrs:{"deadline":"2020-12-08 20:00:00"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }